/**
 * 小黑盒app内通用参数
 *
 * WEB参数
 * is_prod 是否是生产环境
 * is_inapp 是否在app内
 * route 路由信息
 *  original 域名
 *  path: path
 *  query: query参数(Object)
 *
 * 客户端参数
 * user_id 用户id(heybox_id)
 * version 客户端版本
 * os_type 客户端系统 iOS | Android
 * debug 是否是测试版
 * src 页面的打开路径 **可能没有**
 */
import { getHeyboxEnv, getParams, isInHeybox } from '_lib/utils';

function getRouteInfo() {
  return {
    origin: window.location.origin,
    path: window.location.pathname,
    query: getParams() || {},
  };
}

export default {
  install(Vue) {
    let client_env = getHeyboxEnv();
    Vue.prototype.$hb_env = {
      is_prod: IS_PRO,
      is_inapp: isInHeybox(),
      route: getRouteInfo(),
      ...client_env,
    };
  },
};
